var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdateApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    height: 126,
    viewBox: "0 0 128 126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "a",
    cx: 63.576,
    cy: 63,
    rx: 63.576,
    ry: 63
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "21.47%",
    x2: "76.904%",
    y1: "-3.252%",
    y2: "102.272%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF3C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFE392"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFD663",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(28 30)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71.1,
    height: 140.305,
    x: 0.9,
    y: 0.596,
    fill: "url(#c)",
    rx: 13.365
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffd663",
    strokeLinecap: "round",
    strokeWidth: 2.97,
    d: "M30.5 9.433h12.166"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCFBF7",
    d: "M.9 17.575H72v105.452H.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#65AEFC",
    d: "M17.137 57.021l8.987-8.986 8.95 8.95-8.987 8.986z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3993F2",
    d: "M27.554 46.845l8.986-8.986 8.95 8.95-8.987 8.986z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E88E8",
    d: "M37.772 57.01l8.987-8.987 8.95 8.95-8.987 8.987z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateApp);
export default __webpack_public_path__ + "static/media/update-app.b7408c02ec18622dc535c737f9d17fc8.svg";
export { ForwardRef as ReactComponent };